import en from './_en';
import ru from './_ru';
import uk from './_uk';

export default { en, ru, uk };